import { render, staticRenderFns } from "./WalletModal.vue?vue&type=template&id=6c4dea7e&"
import script from "./WalletModal.vue?vue&type=script&lang=ts&"
export * from "./WalletModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports